import { render, staticRenderFns } from "./MDetailPrice.vue?vue&type=template&id=b0ca8866&scoped=true"
import script from "./MDetailPrice.vue?vue&type=script&lang=js"
export * from "./MDetailPrice.vue?vue&type=script&lang=js"
import style0 from "./MDetailPrice.vue?vue&type=style&index=0&id=b0ca8866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ca8866",
  null
  
)

export default component.exports